export const PILOT_MODULATORS_ACQ_RATE_CARD_ENGLISH_LOCALE = {
  title: "Acquisition rate",
  subtitle: "Last 24h",
};
